import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoPhoneNumberInput } from "@redotech/redo-web/arbiter-components/input/redo-phone-number-input";
import { Flex } from "@redotech/redo-web/flex";
import { PhoneWidgetNumpad } from "@redotech/redo-web/voice/shared/phone-numpad";
import { memo, useContext } from "react";
import { VoiceContextV2 } from "./voice-context-v2";

/**
 * Idle screen for the v2 phone widget — phone number input + numpad +
 * Call button. Mirrors v1's `phone-idle.tsx` but consumes
 * `VoiceContextV2`. Status switching + settings button live in the
 * panel header, so this body is just the dialer. The typed number
 * lives on the context so it survives collapse/expand of the widget.
 */
export const PhoneIdleV2 = memo(function PhoneIdleV2() {
  const ctx = useContext(VoiceContextV2);
  if (ctx == null) {
    throw new Error("VoiceContextV2 missing");
  }

  const number = ctx.dialerNumber;
  const setNumber = ctx.setDialerNumber;
  // Don't gate on connection status — `placeOutbound` will auto-go-
  // online if the operator is offline. We only need a non-empty
  // number AND no in-flight dial (otherwise the operator could
  // double-click and place two calls).
  const ready = number.trim().length > 0 && !ctx.isPlacingOutbound;

  return (
    <Flex dir="column" gap="md" p="xl">
      <RedoPhoneNumberInput setValue={setNumber} value={number} />
      <PhoneWidgetNumpad itemPressed={(d) => setNumber(number + d)} />
      <RedoButton
        disabled={!ready}
        hierarchy="primary"
        onClick={() => ctx.placeOutbound(number)}
        text={ctx.isPlacingOutbound ? "Calling…" : "Call"}
        theme="success"
      />
    </Flex>
  );
});
